import Vue from 'vue'
import Vuex from 'vuex'
import loadStatePlugin from './plugins/loadState'
import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import roles from './modules/roles'
import payroll from './modules/payroll'
import profile from './modules/profile'
import shifts from './modules/shifts'
import payment from './modules/payment'
import stripe from './modules/stripe'
import report from './modules/report'
import paycode from './modules/paycode'
import document from './modules/document'
import search from './modules/search'
import legalEntity from './modules/legal-entity'
import department from './modules/department'
import alerts from './modules/alerts'
import modals from './modules/modals'
import refbook from './modules/refbook'
import completeRequest from './modules/complete-request'
import sequence from './modules/sequence'
import project from './modules/project'
import workArea from './modules/work-area'
import chats from './modules/chats'
import user from './modules/user'
import timeOff from './modules/time-off'
import bookmarks from './modules/bookmarks'
import pointSystem from './modules/point-system'
import agent from './modules/agent'
import disciplinary from './modules/disciplinary'
import workspace from './modules/workspace'
import pbjAudit from './modules/pbj-audit'

Vue.use(Vuex)

export const applicationStateModule = {
  state,
  mutations,
  actions,
  getters
}

export default new Vuex.Store({
  modules: {
    applicationState: applicationStateModule,
    payroll,
    roles,
    profile,
    shifts,
    payment,
    stripe,
    report,
    paycode,
    document,
    search,
    legalEntity,
    department,
    alerts,
    modals,
    refbook,
    completeRequest,
    sequence,
    project,
    workArea,
    chats,
    user,
    timeOff,
    bookmarks,
    pointSystem,
    agent,
    disciplinary,
    workspace,
    pbjAudit
  },
  plugins: [loadStatePlugin]
})
